(function (window2, document2, $) {
 
    "use strict";



    var IPSTACK_ACCESS_KEY = "1013a0e5619c2054a66ac712aba870c8",

        IPSTACK_ENDPOINT = "https://api.ipstack.com/check",

        COOKIE_NAME = "geo_country_code",

        COOKIE_EXPIRES_DAYS = 1,

        AU_HOST = "aus.moanabikini.com",

        OTHER_HOST = "moanabikini.com",

        COOKIE_OPTIONS = {

            expires: COOKIE_EXPIRES_DAYS,

            path: "/",

            secure: true

        };



    function getQueryParam(name) {

        try {

            var url = new URL(window2.location.href);

            return url.searchParams.get(name);

        } catch (e) {

            var match = new RegExp("[?&]" + name + "=([^&]*)").exec(window2.location.search);

            return match && decodeURIComponent(match[1].replace(/\+/g, " "));

        }

    }



    function isBypassEnabled() {

        var val = (getQueryParam("bypass") || "").toLowerCase();

        return val === "true" || val === "1" || val === "yes";

    }



    function cookieAvailable() {

        return typeof $.cookie === "function";

    }



    function getTargetHost(countryCode) {

        var cc = (countryCode || "").toUpperCase();

        return (cc === "AU" || cc === "NZ") ? AU_HOST : OTHER_HOST;

    }



    function currentHost() {

        return window2.location.host.toLowerCase();

    }



    function buildRedirectUrl(targetHost) {

        return window2.location.protocol + "//" + targetHost + window2.location.pathname + window2.location.search + window2.location.hash;

    }



    function maybeRedirect(countryCode) {

        var targetHost = getTargetHost(countryCode);



        if (currentHost() === targetHost) {

            return;

        }



        window2.location.replace(buildRedirectUrl(targetHost));

    }



    function handleCountry(countryCode) {

        if (!countryCode) return;



        if (cookieAvailable()) {

            $.cookie(COOKIE_NAME, String(countryCode).toUpperCase(), COOKIE_OPTIONS);

        }



        maybeRedirect(countryCode);

    }



    $(function () {

        if (isBypassEnabled()) return;



        var cachedCountry = cookieAvailable() ? $.cookie(COOKIE_NAME) : null;

        if (cachedCountry) {

            maybeRedirect(cachedCountry);

            return;

        }



        if (!IPSTACK_ACCESS_KEY || IPSTACK_ACCESS_KEY === "YOUR_IPSTACK_ACCESS_KEY") {

            console.warn("[geo-redirect] Missing ipstack access key. No redirect performed.");

            return;

        }



        $.ajax({

            url: IPSTACK_ENDPOINT,

            method: "GET",

            dataType: "json",

            cache: true,

            data: {

                access_key: IPSTACK_ACCESS_KEY

            },

            timeout: 6000

        }).done(function (data) {

            var countryCode = data && (data.country_code || data.countryCode);

            handleCountry(countryCode);

        }).fail(function () {

            console.warn("[geo-redirect] Geo lookup failed. Staying on current site.");

        });

    });



})(window, document, window.jQuery);